module.exports = __webpack_public_path__ + "img/NEXO.d88326dd.svg";